import React from "react"
import { observer } from "mobx-react-lite"
import { CircularProgress } from "@mui/material"
import Field from "../../../../form/fields/Field"
import { store } from "../../../../../stores/Store"
import ErrorBoundary from "../../../../../misc/ErrorBoundary"
import AutomationCta from "./AutomationCta"
import AutomationListItem from "./AutomationListItem"
import { Automator } from "../../../../../models/Automator"
import AutomationNode from "../../../../../models/AutomationNode"
import { UTCDate } from "@date-fns/utc"


interface AutomationSection {
    automationNode: AutomationNode;
    hideOldVersions?: boolean
}


export default observer(function AutomationSection ({
    automationNode,
    hideOldVersions = true
}: AutomationSection) {

    const [showOldVersions, setShowOldVersions] = React.useState(!hideOldVersions)

    var automations = [...automationNode.automations].sort((a, b) => b.run_at?.localeCompare(a.run_at))
    
    const isNewest = (automator) => {

        var newerVersion = automations.find((a) => {
            var run_at1 = new UTCDate(automator.run_at)
            var run_at2 = new UTCDate(a.run_at)
            var firstName1 = automator.profile?.subject_first_name
            var firstName2 = a.profile?.subject_first_name
            
            if (automator.id !== a.id && automator.automation_id === a.automation_id) {
                if (automator.automation_id.includes("CHILD")) {
                    return firstName1 === firstName2 && run_at1 < run_at2
                } else {
                    return run_at1 < run_at2
                }
            }
            return false
        })

        return !newerVersion
    }

    const runningAutomator = store.AutomationStore.runningAutomation?.automator
    var automationsToShow = showOldVersions ? automations : automations.filter(a => isNewest(a))

    // Remove duplicate automator if there is a more up to date runningAutomator
    if (runningAutomator) {
        automationsToShow = automationsToShow.filter(a => a.id !== runningAutomator.id)
    }

    return (
        <ErrorBoundary>
            <div className="detail-section">
                <div className="section-header">
                    <div className="header">
                        <h4>Automations</h4>

                        <Field.Checkbox 
                            label="Show old versions" 
                            className="field-checkbox-sm"
                            value={showOldVersions} 
                            warning={false} 
                            onChange={() => setShowOldVersions(!showOldVersions)} />
                    </div>
                </div>

                <AutomationCta enquiryUid={automationNode.enquiry?.uid} automationNodeUid={automationNode.uid} />
                
                {runningAutomator && store.NodeStore.leafNode?.uid === store.AutomationStore.runningAutomation?.parentUid ? (
                    <>
                        <div className="section-subheader">
                            <h5>Running automation <CircularProgress style={{ width: "8px", height: "8px", margin: "0 0 0 5px" }} /></h5>
                        </div>

                        <AutomationListItem label={runningAutomator.label} automator={runningAutomator} />
                    </>
                ) : null}

                {automationsToShow?.length ? (
                    <>
                        <div className="section-subheader">
                            <h5>Previous automations</h5>
                        </div>

                        {automationsToShow.map((automator, i) => <AutomationListItem key={i} label={automator.label} automator={automator} /> )}
                    </>
                ) : null}
            </div>
        </ErrorBoundary>
    )
})